import request from '@/utils/request'

export function reservationSave(data) {
  return request({
    url: 'reservation/save',
    method: 'post',
    data
  })
}


export default { reservationSave }